import { downloadFileFromResponse } from "apis/localhost";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { exportListToCSV } from "slices/watchwords/actions";

const useExportToCsvHandler = (name, listId) => {
  const dispatch = useDispatch();

  return useCallback(async () => {
    const blob = await dispatch(exportListToCSV(listId));
    if (blob) {
      downloadFileFromResponse(blob, `${name}.csv`);
    }
  }, [name, listId]);
};

export default useExportToCsvHandler;
